import React, { useEffect, useState } from "react";
import API from "libs/api";
import { useParams } from "react-router-dom";
import ICON from "components/cmp_icon/cmp_icon";

import './tab_ages.css';
// import {Button} from "semantic-ui-react";



export default function TAB_AGES({ current_tab }) {

    //  variable declarations ------------------------------------------------------------------------------------------

    const { provider_id } = useParams();

    const [ var_data, set_data ] = useState([]);
    const [ var_processing, set_processing ] = useState('inactive');
    const [ var_updating_data, set_updating_data ] = useState(false);



    //  event listeners ------------------------------------------------------------------------------------------------

    useEffect(() => {
        if (current_tab === 'AGES' && provider_id) {
            get_ages();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [current_tab, provider_id]);

    useEffect(() => {
        if (var_updating_data) {
            put_ages();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [var_data]);


    //  async functions ------------------------------------------------------------------------------------------------

    async function get_ages(){

        set_processing('processing');

        try {
            let results = await API_get_ages();
            if (!results) {
                results = {};
                results.provider_id = provider_id;
            }
            console.log(results);
            set_data(results);
            set_processing('inactive');
        } catch (e) {
            set_processing('error');
            console.log(e);
        }

    }

    async function put_ages() {

        set_processing('processing');

        try {
            await API_put_ages();
            set_processing('inactive');
            set_updating_data(false);
            get_ages();
        } catch (e) {
            set_processing('error');
            console.log(e);
        }
    }



    //  API calls ------------------------------------------------------------------------------------------------------

    function API_get_ages(){
        return API.get('admin-providers', '/get-provider-ages/' + provider_id);
    }

    function API_put_ages(){
        return API.put('admin-providers', '/put-provider-ages',{ body: var_data});
    }



    //  event functions ------------------------------------------------------------------------------------------------

    function onClick_age(age){
        let data = {...var_data};
        if (data[age] === 'YES'){
            data[age] = 'NO';
        } else if (data[age] === 'NO'){
            data[age] = 'YES';
        }
        set_data(data);
        set_updating_data(true);
    }


    // RENDER CONTAINER ================================================================================================

    return (

        <div id='tab__page--provider_ages' className='tab__page tab__transition'>

            <div className='card__wrapper'>

                {/*<div className={'card option' + (var_data.young_children === 'YES' ? ' active' : '')} onClick={()=>onClick_age('young_children')}>*/}

                {/*    <div className='card__content'>*/}
                {/*        <div className='option__icon'>*/}
                {/*            <ICON name='bear' className='icon' alt='bear icon'/>*/}
                {/*        </div>*/}
                {/*        <div className='option__text__wrapper'>*/}
                {/*            <div className='text--md bold option__text__title'>*/}
                {/*                Young children*/}
                {/*                {var_data.young_children === 'YES' &&*/}
                {/*                    <ICON name='checkmark' className='icon' alt='checkmark icon'/>*/}
                {/*                }*/}
                {/*            </div>*/}
                {/*            <div className='text--base'>Pre-school children between the ages of 0 and 5</div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div className={'card option' + (var_data.children === 'YES' ? ' active' : '')} onClick={()=>onClick_age('children')}>*/}
                {/*    <div className='card__content'>*/}
                {/*        <div className='option__icon'>*/}
                {/*            <ICON name='child' className='icon' alt='child icon'/>*/}
                {/*        </div>*/}
                {/*        <div className='option__text__wrapper'>*/}
                {/*            <div className='text--md bold option__text__title'>*/}
                {/*                Children*/}
                {/*                {var_data.children === 'YES' &&*/}
                {/*                    <ICON name='checkmark' className='icon' alt='checkmark icon'/>*/}
                {/*                }*/}
                {/*            </div>*/}
                {/*            <div className='text--base'>School aged children between the ages of 6 and 12</div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div className={'card option' + (var_data.teens === 'YES' ? ' active' : '')} onClick={()=>onClick_age('teens')}>*/}
                {/*    <div className='card__content'>*/}
                {/*        <div className='option__icon'>*/}
                {/*            <ICON name='teen' className='icon' alt='teen icon'/>*/}
                {/*        </div>*/}
                {/*        <div className='option__text__wrapper'>*/}
                {/*            <div className='text--md bold option__text__title'>*/}
                {/*                Teen*/}
                {/*                {var_data.teens === 'YES' &&*/}
                {/*                    <ICON name='checkmark' className='icon' alt='checkmark icon'/>*/}
                {/*                }</div>*/}
                {/*            <div className='text--base'>Teens between the ages of 13 and 17</div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div className={'card option' + (var_data.adults === 'YES' ? ' active' : '')} onClick={()=>onClick_age('adults')}>*/}
                {/*    <div className='card__content'>*/}
                {/*        <div className='option__icon'>*/}
                {/*            <ICON name='woman' className='icon' alt='woman icon'/>*/}
                {/*        </div>*/}
                {/*        <div className='option__text__wrapper'>*/}
                {/*            <div className='text--md bold option__text__title'>*/}
                {/*                Adults*/}
                {/*                {var_data.adults === 'YES' &&*/}
                {/*                    <ICON name='checkmark' className='icon' alt='checkmark icon'/>*/}
                {/*                }*/}
                {/*            </div>*/}
                {/*            <div className='text--base'>18 years of age and older</div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

                {/*<div className={'card option' + (var_data.seniors === 'YES' ? ' active' : '')} onClick={()=>onClick_age('seniors')}>*/}
                {/*    <div className='card__content'>*/}
                {/*        <div className='option__icon'>*/}
                {/*            <ICON name='senior' className='icon' alt='senior icon'/>*/}
                {/*        </div>*/}
                {/*        <div className='option__text__wrapper'>*/}
                {/*            <div className='text--md bold option__text__title'>*/}
                {/*                Seniors*/}
                {/*                {var_data.seniors === 'YES' &&*/}
                {/*                    <ICON name='checkmark' className='icon' alt='checkmark icon'/>*/}
                {/*                }*/}
                {/*            </div>*/}
                {/*            <div className='text--base'>Seniors aged 55+</div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}

            </div>
        </div>
    );
}
